import { defineMessage } from 'react-intl';
import { AppMessageType } from '../../../core/src/shared/enums';

export const appMessagesTextMapping: Record<
  AppMessageType,
  {
    title: ReturnType<typeof defineMessage>;
    body?: ReturnType<typeof defineMessage>;
  }
> = {
  [AppMessageType.Test]: {
    title: defineMessage({
      id: 'app_messages.test',
      defaultMessage: 'Testovací notifikace',
    }),
  },
  [AppMessageType.SpotNegativePriceStart]: {
    title: defineMessage({
      id: 'app_messages.spot_negative_price_start',
      defaultMessage: 'Cena spotu je záporná',
    }),
    body: defineMessage({
      id: 'app_messages.body.spot_negative_price_start',
      defaultMessage:
        'Aktuální cena na spotu je po odečtení provize záporná. Provize nastavená v Infigy je ve výši {spotOffsetPrice, number, ::.##} Kč. Aktuální cena spotu je {spotNegativePrice, number, ::.##} Kč.',
    }),
  },
  [AppMessageType.SpotNegativePriceStop]: {
    title: defineMessage({
      id: 'app_messages.spot_negative_price_stop',
      defaultMessage: 'Cena spotu již není záporná',
    }),
    body: defineMessage({
      id: 'app_messages.body.spot_negative_price_stop',
      defaultMessage:
        'Aktuální cena na spotu již není záporná a je ve výši {spotNegativePrice, number, ::.##} Kč. Provize je v Infigy nastavená ve výši {spotOffsetPrice, number, ::.##} Kč',
    }),
  },
  [AppMessageType.UtilityLossStart]: {
    title: defineMessage({
      id: 'app_messages.utility_loss_start',
      defaultMessage: 'Zaznamenali jsme výpadek distribuční sítě',
    }),
  },
  [AppMessageType.UtilityLossStop]: {
    title: defineMessage({
      id: 'app_messages.utility_loss_stop',
      defaultMessage: 'Výpadek distribuční sítě byl odstraněn',
    }),
  },
  [AppMessageType.InverterProductionMWH]: {
    title: defineMessage({
      id: 'app_messages.inverter_production_mwh',
      defaultMessage: 'Milník ve výrobě FVE',
    }),
    body: defineMessage({
      id: 'app_messages.body.inverter_production_mwh',
      defaultMessage:
        'Letos vám vaše fotovoltaická elektrárna již vyrobila {inverterProductionValue, number, ::.##} MWh.',
    }),
  },
  [AppMessageType.InverterDisconnected]: {
    title: defineMessage({
      id: 'app_messages.inverter_disconnected',
      defaultMessage: 'Ztráta komunikace se střídačem',
    }),
  },
  [AppMessageType.InverterConnected]: {
    title: defineMessage({
      id: 'app_messages.inverter_connected',
      defaultMessage: 'Navázání komunikace se střídačem',
    }),
  },
  [AppMessageType.HeatWaterMaxTemperature]: {
    title: defineMessage({
      id: 'app_messages.heat_water_max_temperature',
      defaultMessage: 'Dosažena požadovaná maximální teplota vody',
    }),
    body: defineMessage({
      id: 'app_messages.body.heat_water_max_temperature',
      defaultMessage:
        'Dnes již došlo k nahřátí bojleru na požadovanou maximální teplotu {maxTemperature, number, ::.##}°C.',
    }),
  },
  [AppMessageType.WallboxStartCharging]: {
    title: defineMessage({
      id: 'app_messages.wallbox_start_charging',
      defaultMessage: 'Začalo nabíjení elektromobilu',
    }),
  },
  [AppMessageType.WallboxStopCharging]: {
    title: defineMessage({
      id: 'app_messages.wallbox_stop_charging',
      defaultMessage: 'Nabíjení elektromobilu bylo ukončeno',
    }),
    body: defineMessage({
      id: 'app_messages.body.wallbox_stop_charging',
      defaultMessage:
        'V tomto cyklu bylo dodáno {wallboxConsumptionCycleValue, number, ::.##} kWh energie.',
    }),
  },
  [AppMessageType.WallboxLimitExceeded]: {
    title: defineMessage({
      id: 'app_messages.wallbox_limit_exceeded',
      defaultMessage: 'Byl překročen dnešní limit nabíjení elektromobilu',
    }),
    body: defineMessage({
      id: 'app_messages.body.wallbox_limit_exceeded',
      defaultMessage:
        'Byl překročen dnešní limit nabíjení elektromobilu. Limit je {value, number, ::.##} kWh.',
    }),
  },
  [AppMessageType.HeatWaterLimitExceeded]: {
    title: defineMessage({
      id: 'app_messages.heat_water_limit_exceeded',
      defaultMessage: 'Byl překročen dnešní limit ohřevu vody',
    }),
    body: defineMessage({
      id: 'app_messages.body.heat_water_limit_exceeded',
      defaultMessage:
        'Byl překročen dnešní limit ohřevu vody. Limit je {value, number, ::.##} kWh.',
    }),
  },
  [AppMessageType.HeatPumpLimitExceeded]: {
    title: defineMessage({
      id: 'app_messages.heat_pump_limit_exceeded',
      defaultMessage: 'Byl překročen dnešní limit spotřeby tepelného čerpadla',
    }),
    body: defineMessage({
      id: 'app_messages.body.heat_pump_limit_exceeded',
      defaultMessage:
        'Byl překročen dnešní limit spotřeby tepelného čerpadla. Limit je {value, number, ::.##} kWh.',
    }),
  },
  [AppMessageType.HomeLimitExceeded]: {
    title: defineMessage({
      id: 'app_messages.home_limit_exceeded',
      defaultMessage: 'Byl překročen dnešní limit spotřeby domácnosti',
    }),
    body: defineMessage({
      id: 'app_messages.body.home_limit_exceeded',
      defaultMessage:
        'Byl překročen dnešní limit spotřeby domácnosti. Limit je {value, number, ::.##} kWh.',
    }),
  },
  [AppMessageType.SpotStartDischargingBattery]: {
    title: defineMessage({
      id: 'app_messages.spot_start_discharging_battery',
      defaultMessage: 'Začalo vybíjení baterie do sítě dle spotové ceny',
    }),
  },
  [AppMessageType.SpotStopDischargingBattery]: {
    title: defineMessage({
      id: 'app_messages.spot_stop_discharging_battery',
      defaultMessage: 'Vybíjení baterie do sítě dle spotové ceny bylo ukončeno',
    }),
  },
  [AppMessageType.SpotStartChargingBattery]: {
    title: defineMessage({
      id: 'app_messages.spot_start_charging_battery',
      defaultMessage: 'Začalo nabíjení baterie dle spotové ceny',
    }),
  },
  [AppMessageType.SpotStopChargingBattery]: {
    title: defineMessage({
      id: 'app_messages.spot_stop_charging_battery',
      defaultMessage: 'Nabíjení baterie dle spotové ceny bylo ukončeno',
    }),
  },
  [AppMessageType.SpotDailySummary]: {
    title: defineMessage({
      id: 'app_messages.spot_daily_summary',
      defaultMessage: 'Denní souhrn plánu spotu',
    }),
    body: defineMessage({
      id: 'app_messages.body.spot_daily_summary',
      defaultMessage: `Dnes na spotu:
        {nothingToReport, select,
          true {Není nic v plánu.}
          other {
            {energyForSale, select,
              true {V plánu je ranní prodej do sítě. }
              other {}
            }
            {negativeIntervals, select,
              false {}
              other {Záporná cena ({negativeIntervals}), při které se omezí přetok. }
            }
            {chargingIntervals, select,
              false {}
              other {Plán nabíjení baterie ({chargingIntervals}). }
            }
            {dischargingIntervals, select,
              false {}
              other {Plán vybíjení baterie do sítě ({dischargingIntervals}). }
            }
          }
        }`,
    }),
  },
  [AppMessageType.SpotDailyPrediction]: {
    title: defineMessage({
      id: 'app_messages.spot_daily_prediction',
      defaultMessage: 'Denní předpověď',
    }),
    body: defineMessage({
      id: 'app_messages.body.spot_daily_prediction',
      defaultMessage: `Denní předpověď:
        {pvPrediction, select,
          true {Výroba elektrárny: {pvPredictionValue, number, ::.##} kWh. }
          other {}
        }
        {homePrediction, select,
          true {Běžná spotřeba domu: {homePredictionValue, number, ::.##} kWh. }
          other {}
        }
        {batteryPrediction, select,
          true {Dispoziční akumulace baterie: {batteryPredictionValue, number, ::.##} kWh. }
          other {}
        }
        {hwPrediction, select,
          true {Dispoziční akumulace bojleru: {hwPredictionValue, number, ::.##} kWh. }
          other {}
        }
        {hpPrediction, select,
          true {Tepelné čerpadlo je {hpPredictionValue, number, ::.##} kWh. }
          other {}
        }
        {salePrediction, select,
          true {Zbývající energie pro prodej přebytků je {salePredictionValue, number, ::.##} kWh. }
          other {}
        }
      `,
    }),
  },
  [AppMessageType.BatteryMaxSOC]: {
    title: defineMessage({
      id: 'app_messages.battery_max_soc',
      defaultMessage:
        'Nabití baterie na nastavené maximální SOC {maxSoc, number, ::.##}%',
    }),
    body: defineMessage({
      id: 'app_messages.body.battery_max_soc',
      defaultMessage:
        'Aktuální úroveň nabití baterie je {currentSoc, number, ::.##}%.',
    }),
  },
  [AppMessageType.BatteryMinSOC]: {
    title: defineMessage({
      id: 'app_messages.battery_min_soc',
      defaultMessage:
        'Vybití baterie na nastavené minimální SOC {minSoc, number, ::.##}%',
    }),
    body: defineMessage({
      id: 'app_messages.body.battery_min_soc',
      defaultMessage:
        'Aktuální úroveň nabití baterie je {currentSoc, number, ::.##}%.',
    }),
  },
};
